import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex justify-end" }
const _hoisted_2 = { class: "flex flex-row space-x-3 mb-4" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "text-xs font-semibold items-center text-left" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-px bg-gray-200" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: _normalizeClass(["w-full border border-transparent p-2 rounded-lg hover:border-primary cursor-pointer transition-all delay-75", _ctx.selected === _ctx.candidate.id && 'border-gray-400']),
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => _ctx.clickCard(), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", {
          class: "p-1 text-xs rounded-lg",
          style: _normalizeStyle(_ctx.buildColorStep(_ctx.candidate.current_stage))
        }, _toDisplayString(_ctx.candidate.current_stage), 5)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Avatar, {
          name: `${_ctx.candidate?.candidate?.first_name} ${_ctx.candidate?.candidate?.last_name}`,
          variant: "xs"
        }, null, 8, ["name"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(`${_ctx.candidate?.candidate?.first_name} ${_ctx.candidate?.candidate?.last_name}`), 1),
          _createElementVNode("span", {
            class: "text-xs text-gray-500",
            innerHTML: _ctx.uploadedBy(_ctx.candidate.application, _ctx.candidate.staff)
          }, null, 8, _hoisted_5)
        ])
      ])
    ], 2),
    _hoisted_6
  ], 64))
}